
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'RobotToolLaunchPopup',
  props: {
    description: {
      type: String as PropType<string | undefined>,
      required: true
    },
    commandText: {
      type: String as PropType<string | undefined>,
      required: true
    },
    exit: {
      type: Function as PropType<() => void>,
      required: true
    }
  },
  methods: {
    async copyText() {
      if (!this.commandText) return;
      try {
        await navigator.clipboard.writeText(this.commandText);
      } catch {
        console.warn('failed to copy command');
      }
    }
  }
});
